import { Link } from "react-router-dom";
import { TbAdjustments } from "react-icons/tb";
import { StablesWithdrawLimitBarSkeleton } from "../../../Components/Molecules/DashboardSkeleton";
import intl from "react-intl-universal";
import { formatCurrency } from "../../../Utils/formatters";
import { useStablesLimitsContext } from "../../../Contexts/StablesLimitsContext";
import { calcLimitPercent, getLimitTone, resolveLimitAvailableCents } from "./StablesLimits/constants";

export const StablesOperationLimitBar = ({ operation }) => {
  const { getLimitForOperation, loading, error, reload } = useStablesLimitsContext();
  const limit = getLimitForOperation(operation);
  const { label, description, usedCents, totalCents } = limit;
  const availableCents = resolveLimitAvailableCents(limit);
  const percent = calcLimitPercent(usedCents, totalCents);
  const tone = getLimitTone(percent);

  if (loading) {
    return <StablesWithdrawLimitBarSkeleton />;
  }

  if (error) {
    return (
      <section className="app-card app-empty-state mb-6">
        <p>{intl.get("stables.limitsLoadError")}</p>
        <button type="button" className="btn-outline mt-2 !rounded-full !px-4" onClick={reload}>
          {intl.get("stables.retryLoad")}
        </button>
      </section>
    );
  }

  return (
    <section className="app-card mb-6 overflow-hidden p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-bold text-brand-dark">{label}</p>
          {description && (
            <p className="mt-0.5 text-xs text-gray-500">{description}</p>
          )}
        </div>
        <Link
          to="/stables/limites"
          className="link-no-zoom inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-[#e7a73f] transition hover:text-brand-dark"
        >
          <TbAdjustments className="h-3.5 w-3.5" />
          {intl.get("stables.operationLimit.viewLimits")}
        </Link>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
        <div>
          <p className="text-[11px] text-gray-400">
            {intl.get("stables.operationLimit.usedLabel")}
          </p>
          <p className="text-sm font-semibold text-brand-dark">
            {formatCurrency(usedCents)}
          </p>
        </div>
        <div>
          <p className="text-[11px] text-gray-400">
            {intl.get("stables.operationLimit.remainingLabel")}
          </p>
          <p className="text-sm font-semibold text-emerald-600">
            {formatCurrency(availableCents)}
          </p>
        </div>
        <div className="col-span-2 sm:col-span-1">
          <p className="text-[11px] text-gray-400">
            {intl.get("stables.operationLimit.limitLabel")}
          </p>
          <p className="text-sm font-semibold text-brand-dark">
            {formatCurrency(totalCents)}
          </p>
        </div>
      </div>

      <div className="cartoes-progress mt-4">
        <div className="cartoes-progress__track">
          <div
            className={`cartoes-progress__fill cartoes-progress__fill--${tone}`}
            style={{ width: `${percent}%` }}
          />
        </div>
        <p className="cartoes-progress__label">
          {intl.get("stables.operationLimit.percentUsed", { percent })}
        </p>
      </div>
    </section>
  );
};
